import { createAgent, updateAgent as editAgent, getAgents } from '../utils/apiService';

export const CREATE_AGENT = 'agent/CREATE_AGENT';
export const CREATE_AGENT_PENDING = 'agent/CREATE_AGENT_PENDING';
export const CREATE_AGENT_FULFILLED = 'agent/CREATE_AGENT_FULFILLED';
export const CREATE_AGENT_REJECTED = 'agent/CREATE_AGENT_REJECTED';

export const LIST_AGENTS = 'agent/LIST_AGENTS';
export const LIST_AGENTS_PENDING = 'agent/LIST_AGENTS_PENDING';
export const LIST_AGENTS_REJECTED = 'agent/LIST_AGENTS_REJECTED';
export const LIST_AGENTS_FULFILLED = 'agent/LIST_AGENTS_FULFILLED';

export const UPDATE_AGENT = 'agent/UPDATE_AGENT';
export const UPDATE_AGENT_PENDING = 'agent/UPDATE_AGENT_PENDING';
export const UPDATE_AGENT_FULFILLED = 'agent/UPDATE_AGENT_FULFILLED';
export const UPDATE_AGENT_REJECTED = 'agent/UPDATE_AGENT_REJECTED';


export const saveAgent = (agent) => {
    const payload = createAgent(agent);
    return {
        type: CREATE_AGENT,
        payload
    }
}

export const updateAgent = (agent) => {
    const payload = editAgent(agent);
    return {
        type: UPDATE_AGENT,
        payload
    }
}

export const listAgents = () => {
    const payload = getAgents();
    return {
        type: LIST_AGENTS,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/agents.js